import React, { Component } from 'react';
import L from 'leaflet';
import { Marker, Popup } from 'react-leaflet';

import { carsStatuses } from '../../../sections/cars/static.carsStatuses';
import { getMarker } from '../../../../shared/map/getMarker';
import { poupupContent } from '../../../../services/PoupUpService/poupupService';

import geocoderService from '../../../../shared/services/geocoderService';

import getDates from '../../../../shared/services/date.service';

import './mapMarkerLastState.scss';

class MapMarkerLastState extends Component {
  onClickHandler(e) {
    const { unit } = this.props;

    const datas = [
      { title: 'Транспортное средство', value: unit.title },
      { title: 'Регистрационный номер', value: unit.registerNumber },
      {
        title: 'Время',
        value: getDates.getDateFormat8(unit.lastState.lastActive),
      },
      { title: 'Долгота', value: unit.lastState.long },
      { title: 'Широта', value: unit.lastState.lat },
      { title: 'Зажигание', value: unit.lastState.ignition ? 'Вкл' : 'Выкл' },
    ];

    geocoderService
      .reverse({ lat: unit.lastState.lat, lon: unit.lastState.long })
      .then((response) => {
        datas.push({ title: 'Адрес', value: response.data.address });
        e.target._popup.setContent(poupupContent({ datas }));
      })
      .catch((error) => {
        e.target._popup.setContent(poupupContent({ datas }));
      });

    e.target._popup.setContent(poupupContent({ datas }));
  }

  render() {
    const { unit } = this.props;

    const position = [unit.lastState.lat, unit.lastState.long];
    const status = unit.lastState?.status?.id;
    const number = unit.number;

    const markerIcon = L.divIcon({
      iconSize: [53, 63],
      iconAnchor: [28, 52],
      popupAnchor: [0, -63],
      className: 'mapMarkerLastState ' + getMarkerState(status),
      html: getMarker('inner', number),
    });

    return (
      <Marker
        position={position}
        icon={markerIcon}
        eventHandlers={{
          click: this.onClickHandler.bind(this),
        }}
      >
        {this.props.children}
        <Popup className="mapPopup" />
      </Marker>
    );
  }
}

const getMarkerState = function (status) {
  var markerStatus;

  Object.values(carsStatuses).map((item) => {
    if (status === item.id) {
      markerStatus = item.name;
    }
    return null;
  });

  return markerStatus;
};

export default React.memo(MapMarkerLastState);
